import { useTranslation } from 'react-i18next';

import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import Table from "../Invoices/Table/Table";
import VirtualBatteryDownload from "./VirtualBatteryDownload";
import VirtualBatteryDiscountToggle from "./VirtualBatteryDiscountToggle";
import VirtualBatteryDiscountSelect from "./VirtualBatteryDiscountSelect";
import ChangePercentageVirtualBatteryDialogOpenButton from './components/ChangeBatteryPercentageDialog/ChangeBatteryPercentageDialogOpenButton';
import BateriaVirtualMoveVirtualBatteryDialogOpenButton from './components/MoveVirtualBattery/MoveVirtualBatteryDialogOpenButton';
import { IBateriaVirtual } from './types/virtualBattery';
import { Card, CardHeader, CardContent } from "@mui/material";
import { useContracts } from '../Contracts/hooks/useContracts';


const VirtualBatteryCardList = () => {
  
  const { t } = useTranslation();
  const Settings = useSettingsContext()

  const {
    contracts,
    currentContract: contract
  } = useContracts("electricity");

  function showChangePercentageVirtualBattery(bateriaVirtual: IBateriaVirtual) {
    let res = false;

    let nContracts = 0;
    for (let i = 0; i < contracts.length; i++) {
      for (let j = 0; j < contracts[i].bateria_virtual!.length; j++){
        if (bateriaVirtual.bateria.id == contracts[i].bateria_virtual![j].bateria.id){
          nContracts++;
        }
      }
    }

    if(nContracts > 1){
      res = true
    }

    return res;
  }

  function showBateriaVirtualMoveVirtualBattery(bateriaVirtual: IBateriaVirtual) {
    let res = false;

    let otherContractBatteries = 0;
    for (let i=0; i < contracts.length; i++){
      for (let j=0; j < contracts[i].bateria_virtual!.length; j++){
        if (contracts[i].bateria_virtual![j].bateria.id != bateriaVirtual.bateria.id
          && contracts[i].bateria_virtual![j].bateria.name != bateriaVirtual.bateria.name
          && contracts[i].id != contract.id
          ){
            otherContractBatteries++;
        }
      }
    }

    if(otherContractBatteries > 1){
      res = true
    }

    return res;
  }

  const columns = [
    {
      title: t('common:text.altHome_battery'),
      key: "name",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.bateria.name
    }, {
      title: t('common:text.altHome_accumulated'),
      key: "total_desc",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.total_descompte
    }, {
      title: t('common:text.virtual_battery_percentage'),
      key: "percentatge",
      computeValue: (bateriaVirtual: IBateriaVirtual) => bateriaVirtual.pes_percentatge.toFixed(0)
    }, {
      title: t('common:text.altHome_to_discount'),
      key: "gestio_desc",
      computeValue: (bateriaVirtual: IBateriaVirtual) => {
      return <>
        {Settings?.contract?.virtualBattery?.renderType === "toggle" ?
          <VirtualBatteryDiscountToggle 
            bateriaVirtual={bateriaVirtual}
          />
        :
          <VirtualBatteryDiscountSelect 
            bateriaVirtual={bateriaVirtual}
          />
        }
      </>}
    }, {
      title: '',
      key: "percentatge1",
      computeValue: (bateriaVirtual: IBateriaVirtual) => <>
        {showChangePercentageVirtualBattery(bateriaVirtual) &&
          <ChangePercentageVirtualBatteryDialogOpenButton polissaBateriaId={bateriaVirtual.id} />
        }
      </>
    }, {
      title: '',
      key: "percentatge2",
      computeValue: (bateriaVirtual: IBateriaVirtual) => <>
        {showBateriaVirtualMoveVirtualBattery(bateriaVirtual) &&
          <BateriaVirtualMoveVirtualBatteryDialogOpenButton bateriaVirtual={bateriaVirtual} />
        }
      </>
    }
  ];

  return (
    <>
    
      <Card style={{marginBottom: '20px'}}>
        <CardHeader title={ t("common:text.altHome_virtual_battery") } style={{flexGrow: 1}}/>

        <VirtualBatteryDownload batteries={contract.bateria_virtual!} />
        
        <CardContent>
          <Table
            columns={columns}
            loaded={true}
            data={contract.bateria_virtual}
            onRowStatus={null}
          />
        </CardContent>
      </Card>

    </>
  )
}

export default VirtualBatteryCardList